// extracted by mini-css-extract-plugin
export default {"header":"styles_header__VEF9Q","new":"styles_new__Aodrs","itemsAmount":"styles_itemsAmount__wXa4F","inputs":"styles_inputs__1Y2Lk","notes":"styles_notes__A4w1P"};